import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=6924132a&lang=pug&"
import script from "./ProductList.vue?vue&type=script&lang=ts&"
export * from "./ProductList.vue?vue&type=script&lang=ts&"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=6924132a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports